module.exports = __webpack_public_path__ + "static/img/breakfast.474920a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/breakfast.png
// module id = 260
// module chunks = 1